import { Button } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import {styled} from '@mui/material/node/styles';
import {storage} from '../../../config/firebase';
import {getDownloadURL, ref, uploadBytes} from 'firebase/storage';
import Resizer from 'react-image-file-resizer';
import { Box, Grid } from '@mui/material/node';
import * as React from 'react';

export const NodeImageUploader = (props) => {
    const [imageUrl, setImageUrl] = React.useState(props.node?.style?.["background-image"] ?? "");

    React.useEffect(() => {
        setImageUrl(props.node?.style?.["background-image"] ?? "")
    }, [props.node.style, imageUrl]);

    const handleButtonClick = (e) => {
        setImageUrl("");
        props.updateImage("");
    };

    const resizeAndUploadPic = (file) => {
        
        Resizer.imageFileResizer(
            file,
            128,
            128,
            "JPEG",
            80,
            0,
            (resizedPicUri) => {
                uploadImage(resizedPicUri);
            },
            "base64",
            64,
            64
          );
    }

    const uploadImage = async (uri) => {
        if (uri == null) return;

        const blob = await fetch(uri).then((r) => r.blob());
        const fileFromBlob = new File([blob], "example.png");
        const imageRef = ref(storage, `projects/${props.projectId}/${props.node.data.id}.jpeg`);

        uploadBytes(imageRef, fileFromBlob).then(() => {
            getDownloadURL(imageRef).then((url) => {
                setImageUrl(url);
                props.updateImage(url);
            })
        });
    }

    const VisuallyHiddenInput = styled('input')({
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: 1,
            overflow: 'hidden',
            position: 'absolute',
            bottom: 0,
            left: 0,
            whiteSpace: 'nowrap',
            width: 1,
        });

    return (
        <Grid
  container
  spacing={0}
  direction="column"
  alignItems="center"
  justifyContent="center"
>
  <Grid item>
  <Box
        component="img"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
            height: "100%",
            width: "100%",
        }}
        alt="-"
        src={imageUrl}
        />
        <Button
            component="label"
            fullWidth sx={{ mt: "15px" }}
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUpload />}
            onChange={(event) => {resizeAndUploadPic(event.target.files[0])}}
        >
            Upload Image
            <VisuallyHiddenInput type="file" accept="image/jpeg, image/png"/>
        </Button>
        <Button fullWidth sx={{ mt: "5px" }} onClick={handleButtonClick}>Delete Image</Button>
  </Grid>
</Grid>
        
    );
};